export interface ConfigResponse {
    msalTenant: string;
    msalSignInPolicy: string;
    msalApplicationId: string;
    msalInstance: string;
    msalRedirectUri: string;
    homeEndpoint: string;
    homeSubscriptionKey: string;
    gtmID: string;
    cmsAppId: string;
    cmsBaseUrl: string;
    cmsContentType: string;
}

export const chargingConfig = {
    msalTenant: process.env.NEXT_PUBLIC_MSAL_TENANT ?? '',
    msalSignInPolicy: process.env.NEXT_PUBLIC_MSAL_SIGN_IN_POLICY ?? '',
    msalApplicationId: process.env.NEXT_PUBLIC_MSAL_APPLICATION_ID ?? '',
    msalInstance: process.env.NEXT_PUBLIC_MSAL_INSTANCE ?? '',
    msalRedirectUri: process.env.NEXT_PUBLIC_MSAL_REDIRECT_URI ?? '',
    homeEndpoint: process.env.NEXT_PUBLIC_HOME_ENDPOINT ?? '',
    homeSubscriptionKey: process.env.NEXT_PUBLIC_HOME_SUBSCRIPTION_KEY ?? '',
    gtmID: process.env.NEXT_PUBLIC_GTM_ID ?? '',
    cmsAppId: process.env.NEXT_PUBLIC_CMS_APP_ID ?? '',
    cmsBaseUrl: process.env.NEXT_PUBLIC_CMS_BASE_URL ?? '',
    cmsContentType: process.env.NEXT_PUBLIC_CMS_CONTENT_TYPE ?? '',
};
